export const TRANSLATIONS_GLOBAL = {
  sidebar: {
    title: 'global.sidebar.title',
    headerTooltip: 'global.sidebar.header_tooltip',
    sections: {
      prospects: 'global.sidebar.sections.prospects',
      clients: 'global.sidebar.sections.clients'
    },
    help: 'global.sidebar.help'
  },
  footer: {
    copyright: 'global.footer',
    privacyPolicy: 'global.privacy_policy',
    termsAndConditions: 'global.terms_and_conditions',
    recaptcha: 'global.recaptcha_protected.main'
  },
  logout: 'global.logout',
  brokerSelector: {
    label: 'global.broker_selector.label',
    ariaLabel: 'global.broker_selector.aria_label'
  },
  name: 'global.name',
  email: 'global.email',
  phone: 'global.phone',
  company: 'global.company',
  location: 'global.location',
  cancel: 'global.cancel',
  optional: 'global.optional',
  required: 'global.required',
  or: {
    main: 'global.or.main'
  },
  pagination: {
    range: 'global.pagination.range',
    empty: 'global.pagination.empty',
    page: 'global.pagination.page',
    previous: 'global.pagination.previous',
    next: 'global.pagination.next'
  },
  sort: {
    ascending: 'global.sort.ascending',
    descending: 'global.sort.descending'
  },
  button: {
    browseFiles: 'global.button.browse_files'
  }
};

export const TRANSLATIONS_TOAST = {
  loginError: {
    message: 'global.toast.error.description'
  },
  genericError: {
    message: 'toast.generic_error.description'
  }
};

export const TRANSLATIONS_EXTERNAL_BENEFITS = {
  documents: {
    demographics: {
      title: 'external_benefits.documents.demographics.title',
      description: 'external_benefits.documents.demographics.description'
    },
    enrollmentReport: {
      title: 'external_benefits.documents.enrollment_report.title',
      description: 'external_benefits.documents.enrollment_report.description'
    },
    demographicsWithDependents: {
      title: 'external_benefits.documents.demographics_with_dependents.title',
      description: 'external_benefits.documents.demographics_with_dependents.description'
    },
    deductions: {
      title: 'external_benefits.documents.deductions.title',
      description: 'external_benefits.documents.deductions.description'
    },
    sbc: {
      title: 'external_benefits.documents.sbc.title'
    },
    other: {
      title: 'external_benefits.documents.other.title',
      description: 'external_benefits.documents.other.description'
    }
  },
  block: {
    title: 'external_benefits.block.title',
    optional: 'external_benefits.block.optional',
    pending: 'external_benefits.block.pending',
    none: {
      title: 'external_benefits.block.none.title',
      description: 'external_benefits.block.none.description',
      cta: 'external_benefits.block.none.cta'
    },
    inReview: {
      title: 'external_benefits.block.in_review.title',
      description: 'external_benefits.block.in_review.description',
      descriptionNoDate: 'external_benefits.block.in_review.description_no_date',
      cta: 'external_benefits.block.in_review.cta'
    }
  },
  modal: {
    title: 'external_benefits.modal.title',
    subtitle: 'external_benefits.modal.subtitle',
    otherDisclosure: 'external_benefits.modal.other_disclosure',
    submit: 'external_benefits.modal.submit',
    saveChanges: 'external_benefits.modal.save_changes',
    close: 'external_benefits.modal.close',
    closeWithoutSubmitting: 'external_benefits.modal.close_without_submitting',
    confirmationTitle: 'external_benefits.modal.confirmation_title',
    confirmationBody: 'external_benefits.modal.confirmation_body',
    done: 'external_benefits.modal.done',
    error: 'external_benefits.modal.error'
  },
  slot: {
    attach: 'external_benefits.slot.attach',
    remove: 'external_benefits.slot.remove',
    addMore: 'external_benefits.slot.add_more',
    replace: 'external_benefits.slot.replace',
    rejection: 'external_benefits.slot.rejection',
    tooLarge: 'external_benefits.slot.too_large'
  }
};
